import React from 'react';
import Icon from '@material-ui/core/Icon';
import MuiButton from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { appTheme } from '../../theme';

const ButtonIcon = styled(Icon)`
  margin-right: ${appTheme.spacing.small};
`;

function Button({ children, color, icon, variant, ...rest }) {
  const Icon = icon;
  return (
    <MuiButton {...rest} color={color} variant={variant}>
      <React.Fragment>
        {!!icon && (
          <ButtonIcon>
            <Icon />
          </ButtonIcon>
        )}
        {children}
      </React.Fragment>
    </MuiButton>
  );
}

Button.propTypes = {
  children: PropTypes.string.isRequired,

  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  icon: PropTypes.func,
  variant: PropTypes.oneOf(['text', 'outlined', 'contained', 'fab']),
};

Button.defaultProps = {
  color: 'primary',
  variant: 'contained',
};

export default Button;



// WEBPACK FOOTER //
// ./src/modules/common/Button.js